import auth from '@/router/auth'
import CategoryItemIndex from '@/components/help-care-confirms/Index'

export default [
  {
    path: '/help-care-confirms',
    name: 'help-care-confirms-index',
    component: CategoryItemIndex,
    beforeEnter: auth.requireAuth
  }
]



// WEBPACK FOOTER //
// ./src/components/help-care-confirms/router.js